import React, { useState } from 'react';
import { UserCourseService } from '@services/index';
import { useSnackbar } from '@components/utilities/SnackbarProvider';

async function updateEntity(payload, Entity) {
  const entityService = new Entity();
  const entityResponse = await entityService.update(payload);

  if (!entityResponse || !entityResponse.result) {
    return null;
  }

  return entityResponse;
}

const UserEnrolledCourseDelete = (props) => {
  const { selectedEntity, setIsOpen } = props;
  const { openSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);

  const confirmOnClick = async () => {
    try {
      setIsLoading(true);
      const status = { id: 3, name: 'deleted', title: 'Deleted' };
      const response = await updateEntity(
        { id: selectedEntity.usercourse_id, status },
        UserCourseService,
      );

      if (!response || !response.success) {
        openSnackbar('Ocurrio un error al eliminar', 'error');
        return;
      }

      setIsOpen(false);
      openSnackbar('Eliminación exitosa!', 'success');
    } catch (error) {
      console.error(error);
      openSnackbar('Ha ocurrido un error', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const returnOnClick = () => {
    setIsOpen(false);
  };

  return (
    <div className="col-12 mx-auto d-block">
      <div className="card">
        <div className="card-body">
          <div className="container pt-2 text-center">
            <h2 className="mb-2">¿Estás seguro?</h2>
            <p className="fs-5">
              No podrás revertir esta solicitud
            </p>
            <div className="mt-4">
              {isLoading ? (
                <button class="btn btn-danger" disabled type="button">
                  <span
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Loading...
                </button>
              ) : (
                <>
                  <button
                    className="btn btn-danger mr-2"
                    onClick={confirmOnClick}
                  >
                    <i className="fe-trash"></i> Eliminar
                  </button>
                  <button
                    className="btn btn-light btn-action ms-2"
                    onClick={returnOnClick}
                  >
                    <i className="fe-x"></i> Cancelar
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserEnrolledCourseDelete;
